(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementary-products"]) return;
  try {
    
  var initComplementaryCarousel = function() {
    var carousel = document.querySelector("#complementary .product-carousel");
    if (carousel === null) { return; }
    if (typeof jQuery === "undefined" || typeof jQuery.fn.slick === "undefined") { return; }
    var $carousel = jQuery(carousel);
    if ($carousel.hasClass("slick-initialized")) { return; }
    var $arrowsTarget = jQuery("#complementary .complementary-arrows");
    $carousel.slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      appendArrows: $arrowsTarget.length ? $arrowsTarget : undefined,
      dots: false,
      infinite: false,
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  };

  var loadComplementaryProductsIntoSection = function() {
    var complementaryProductsSection = document.querySelector(".complementary-products");
    if (complementaryProductsSection === null) { return; }
    var recommended_url = complementaryProductsSection.dataset.baseUrl;
    var productId = complementaryProductsSection.dataset.productId;
    var limit = complementaryProductsSection.dataset.limit;
    var requestUrl = recommended_url + '?section_id=complementary-products&limit=' + limit + '&product_id=' + productId + '&intent=complementary';

    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        var newContent = container.querySelector(".complementary-products");
        if (newContent) {
          complementaryProductsSection.parentElement.innerHTML = newContent.innerHTML;
        }
      }
      initComplementaryCarousel();
    };
    request.send();
  };
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "complementary-products") {
      loadComplementaryProductsIntoSection();
    }
  });
  loadComplementaryProductsIntoSection();
  initComplementaryCarousel();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var initRelatedCarousel = function() {
    var carousel = document.querySelector("#related .product-carousel");
    if (carousel === null) { return; }
    if (typeof jQuery === "undefined" || typeof jQuery.fn.slick === "undefined") { return; }
    var $carousel = jQuery(carousel);
    if ($carousel.hasClass("slick-initialized")) { return; }
    var $arrowsTarget = jQuery("#related .related-arrows");
    $carousel.slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      appendArrows: $arrowsTarget.length ? $arrowsTarget : undefined,
      dots: false,
      infinite: false,
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  };

  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    var recommended_url = productRecommendationsSection.dataset.baseUrl;

    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL - intent=complementary uses the manually-set "Pair it with" list
    // instead of Shopify's automatic algorithm, so only your chosen pairs ever show here
    var requestUrl = recommended_url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId + '&intent=complementary';

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        var newContent = container.querySelector(".product-recommendations");
        if (newContent) {
          productRecommendationsSection.parentElement.innerHTML = newContent.innerHTML;
        }
      }
      initRelatedCarousel();
    };
    request.send();
  };
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();
  initRelatedCarousel();

  } catch(e) { console.error(e); }
})();
})();
